import { createLoanAppConfig } from "@clcdev/gatsby-theme-application";
import meta from "./meta";
import {
    version,
    fixedHeight,
    transformers,
    steps,
} from "./credit-classic.fr";

const APP_CONFIG_VARIANT = process.env.GATSBY_APP_CONFIG_VARIANT;
const variant = APP_CONFIG_VARIANT || "credit-classic";
const isClassic = variant.toLowerCase().indexOf("classic") !== -1;

const classicMeta = Object.assign({}, meta, {
    version: version,
    fixedHeight: fixedHeight,
    transformers: transformers,
    steps: steps,
});

export default createLoanAppConfig(
    variant,
    isClassic ? classicMeta : meta,
);
